// extracted by mini-css-extract-plugin
export default {"videoItem":"video-item-carousel__videoItem--2GIkc"};
    if(module.hot) {
      // 1792682147115
      var cssReload = require("/bento3/bento_cms/static_src/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  